import { Box, Typography } from "@mui/material";
import { EJobType } from "../../../../../../utils";
import { AdvancedJob } from "./AdvancedJob";
import BasicJob from "./BasicJob";

const JobSummary = ({ data }) => {
  const serviceType = data?.type;

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3, md: 4 },
        width: { xs: "100%", sm: "90%", md: "80%", lg: "70%" },
        mx: "auto",
      }}
    >
      <Typography sx={{ textAlign: "center" }} variant="h5" fontWeight={700} mb={2}>
        Service
      </Typography>
      {serviceType === EJobType.BASIC ? <BasicJob service={data?.scopeOfWork} /> : <AdvancedJob job={data} />}
    </Box>
  );
};

export default JobSummary;
